<template>
  <div>
    <PageAllow controller="Receipt" action="billAnalyze" />
    <Breadcrumbs :items="items" />
    <v-slide-x-transition>
      <v-sheet class="transparent-background-color">
        <v-row dense class="mx-5">
          <v-col cols="12" sm="12" md="4">
            <v-row dense align="center" class="pa-1">
              <SearcherDatetime
                type="month"
                v-model="dateMonth"
                :label="$t('ReceiptBillAnalyzeHistory.Fields.month')"
                removeIcon
              />
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="8" align-self="center">
            <v-row dense align="center" class="search-controls">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="px-0 py-0 caption font-weight-bold grey--text"
                    color="primary"
                    @click.stop="onSearch()"
                  >
                    <v-icon small class="pe-1">fa-search</v-icon>
                    {{ $t("Search.search") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.searchTip") }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="caption font-weight-bold grey--text"
                    @click.stop="resetSearch()"
                  >
                    <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                    {{ $t("Search.reset") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.resetTip") }}</span>
              </v-tooltip>
              <v-divider vertical />
              <v-btn
                class="caption font-weight-bold grey--text"
                :class="
                  $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                "
                small
                text
                @click.stop="$store.commit('toggleSearchPanel')"
              >
                {{ $t("Search.pro") }}
                <v-icon small class="ps-1">{{
                  $store.state.showSearchPanel ? "fa-angle-up" : "fa-angle-down"
                }}</v-icon>
              </v-btn>
              <v-spacer />
              <v-btn
                small
                color="print"
                dark
                class="ms-1"
                v-if="$permission.permissionAllow('Receipt', 'billAnalyzeHistoryExport')"
                @click.stop="billAnalyzeHistoryExport()"
              >
                <v-icon x-small class="pe-1">fa-file-export</v-icon>
                {{ $t("ReceiptBillAnalyzeHistory.batchExports") }}
              </v-btn>
            </v-row>
          </v-col>
        </v-row>
        <v-expansion-panels
          v-model="$store.getters.panels"
          multiple
          flat
          accordion
        >
          <v-expansion-panel class="transparent-background-color">
            <v-expansion-panel-content>
              <v-row dense align="center">
                <v-col cols="12" sm="6" md="4">
                  <SearcherObjType v-model="options.obj_type" />
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <SearcherKeyword
                    ref="keyword"
                    v-model="options.keyword"
                    @text="Keyword = $event"
                    :label="$t('ReceiptBillAnalyzeHistory.Fields.keyword')"
                  />
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        <!-- 表格 -->
        <div class="mx-4 mb-4">
          <v-data-table
            :headers="headers"
            :items="bills"
            :options.sync="options"
            :loading="loading"
            :page.sync="paging.page"
            :server-items-length="paging.count"
            multi-sort
            class="elevation-1 px-4 pt-1 sticky-table"
            id="sticky-table"
            :class="stickTableCols ? 'sticky-first-col sticky-last-col' : ''"
            fixed-header
            :footer-props="$t('$config.footer-props')"
          >
            <!-- 合计 -->
            <template v-slot:header.actions="{ header }">
              {{ header.text }}
              <v-icon x-small>fa-sliders-h</v-icon>
            </template>
            <template v-slot:item.receivable_fee_total="{ item }">
              {{ $t("Global.money") }}{{ item.receivable_fee_total | formatMoney }}
            </template>
            <template v-slot:item.received_total="{ item }">
              {{ $t("Global.money") }}{{ item.received_total | formatMoney }}
            </template>
            <template v-slot:item.wait_receive="{ item }">
              {{ $t("Global.money") }}{{ item.wait_receive | formatMoney }}
            </template>
            <template v-slot:item.pay_fee_total="{ item }">
              {{ $t("Global.money") }}{{ item.pay_fee_total | formatMoney }}
            </template>
            <template v-slot:item.paid_total="{ item }">
              {{ $t("Global.money") }}{{ item.paid_total | formatMoney }}
            </template>
            <template v-slot:item.wait_pay="{ item }">
              {{ $t("Global.money") }}{{ item.wait_pay | formatMoney }}
            </template>
          </v-data-table>
        </div>
      </v-sheet>
    </v-slide-x-transition>
  </div>
</template>

<script>
import PageAllow from "@/components/PageAllow";
import { mapState } from "vuex";
import i18n from "@/i18n";
import Breadcrumbs from "@/components/Breadcrumbs";
import SearcherKeyword from "@/components/plugins/SearcherKeyword";
import SearcherObjType from "@/components/plugins/SearcherObjType";
import SearcherDatetime from "@/components/plugins/SearcherDatetime";
import receipBillAnalyze from "@/api/receip_bill_analyze";

const defaultOptions = {
  month: new Date().toISOString().substr(0, 7),
  obj_type: 1,
  keyword: '',
};

export default {
  data: () => ({
    bills: [],
    paging: {},
    dateMonth: new Date().toISOString().substr(0, 7),
    Keyword: "",
    options: JSON.parse(
      sessionStorage.getItem("receipt-bill-history-options")
        ? sessionStorage.getItem("receipt-bill-history-options")
        : JSON.stringify(defaultOptions)
    ),
    loading: false,
  }),
  components: {
    Breadcrumbs,
    SearcherDatetime,
    PageAllow,
    SearcherKeyword,
    SearcherObjType,
  },
  props: {
    detailMode: Boolean,
  },
  computed: {
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("Nav.fundManagement"),
        disabled: false,
        href: "/receipts",
      },
      {
        text: i18n.t("Nav.receiptBillAnalyze"),
        disabled: false,
        href: "/receipt-bill-analyze",
      },
      {
        text: i18n.t("Nav.receiptBillAnalyzeHistory"),
        disabled: true,
        href: "/receipt-bill-analyze/history",
      },
    ],
    headers() {
      let headers = [
        {
          text: i18n.t("ReceiptBillAnalyzeHistory.Fields.obj_code"),
          align: "start",
          sortable: false,
          value: "obj_code",
        },
        {
          text: i18n.t("ReceiptBillAnalyzeHistory.Fields.obj_name"),
          align: "start",
          sortable: false,
          value: "obj_name",
        },
        {
          text: i18n.t("ReceiptBillAnalyzeHistory.Fields.receivable_fee_total"),
          align: "start",
          sortable: false,
          value: "receivable_fee_total",
        },
        {
          text: i18n.t("ReceiptBillAnalyzeHistory.Fields.received_total"),
          align: "start",
          sortable: false,
          value: "received_total",
        },
        {
          text: i18n.t("ReceiptBillAnalyzeHistory.Fields.wait_receive"),
          align: "start",
          sortable: false,
          value: "wait_receive",
        },
        {
          text: i18n.t("ReceiptBillAnalyzeHistory.Fields.pay_fee_total"),
          align: "start",
          sortable: false,
          value: "pay_fee_total",
        },
        {
          text: i18n.t("ReceiptBillAnalyzeHistory.Fields.paid_total"),
          align: "start",
          sortable: false,
          value: "paid_total",
        },
        {
          text: i18n.t("ReceiptBillAnalyzeHistory.Fields.wait_pay"),
          align: "start",
          sortable: false,
          value: "wait_pay",
        },
      ];
      return headers;
    },
    ...mapState(["stickTableCols"]),
  },

  mounted() {
    this.$commonUtils
      .loadOptions("receipt-bill-history", [])
      .then(
        function (data) {
          if (data.options) {
            this.options = data.options;
            if (typeof this.options.month != "undefined")
              this.dateMonth = this.options.month;
        } else this.resetSearch();
        }.bind(this)
      );
  },
  methods: {
    onSearch() {
      this.options = Object.assign({}, this.options, {
        keyword: this.Keyword,
      });
    },
    resetSearch() {
      this.keyword = null;
      this.dateMonth = new Date().toISOString().substr(0, 7);
      this.options = JSON.parse(JSON.stringify(defaultOptions));
      [this.$refs.keyword].forEach((k) => {
        if (k) k.clear();
      });
    },
    getBillAnalyzeHistoryFromAPI() {
      this.loading = true;
      receipBillAnalyze.getBillAnalyzeHistory(this.options).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.bills = response.data.bill_analyze_history_details;
            this.paging = response.data.paging;
          } else if (response.data.error.code.isNoResultSet()) {
            this.options.page = 1;
          }
          this.loading = false;
        }.bind(this)
      );
    },
    billAnalyzeHistoryExport() {
      receipBillAnalyze.billAnalyzeHistoryExport(Object.assign({}, this.options));
    },
  },
  watch: {
    options: {
      deep: true,
      handler() {
        this.getBillAnalyzeHistoryFromAPI();
        sessionStorage.setItem("receipt-bill-history-options", JSON.stringify(this.options));
      },
    },
    dateMonth: {
      handler() {
        if (this.dateMonth == "") {
          this.dateMonth = new Date().toISOString().substr(0, 7);
        } else {
          this.options.month = this.dateMonth;
        }
      },
    },
  },
};
</script>

<style>
</style>